<template>
    <div>
        <div class="title">保障计划</div>
        <Form :model="form" :label-width="125" ref="form" class="mt15" :rules="formRules">
            <FormItem label="保障起期：" class="w800" prop="projectDateStarts">
                <DatePicker v-model="form.projectDateStarts" type="date" placeholder="请选择保障起期" style="width: 300px"
                    @on-change="dateChange" :options="dateOptions">
                </DatePicker>
                <span class="errorMsg">T+2（工作日生效，节假日顺延）</span>
            </FormItem>
            <FormItem label="保障止期：" class="w600">
                <DatePicker v-model="form.projectDateEnds" type="date" placeholder="请选择保障起期" style="width: 300px"
                    :disabled="true" @on-change="dateChanges ">
                </DatePicker>
            </FormItem>

            <FormItem label="选择类型：" class="w600" required prop="productCode">
                <Select v-model="form.productCode" @on-change="getSceme">
                    <Option value="TUJIAN_LUZHENG">土建项目/路政项目</Option>
                    <Option value="GONGCHENG_ZHUANGXIU">工程装修类</Option>
                    <Option value="XIAOFANG_JIDIAN">消防、机电类</Option>
                    <Option value="WAIQIANG_BAOWEN">外墙保温类</Option>
                </Select>
            </FormItem>
            <FormItem label="选择保额：" class="w600" required prop="scheme">
                <Select v-model="form.scheme" @on-change="setSceme">
                    <Option :value="item.key" v-for="(item,index) in sceneList" :key="index">{{item.value}}</Option>
                </Select>
            </FormItem>
            <FormItem label="合同类型：" class="w600" required prop="contractType">
                <Select v-model="form.contractType" @on-change="setPreminum">
                    <Option value="TOTAL">总包</Option>
                    <Option value="SUB">分包</Option>
                </Select>
            </FormItem>
            <FormItem label="总费用：" class="w800" required>
                <div v-if="!premium" class="priceStyle">

                </div>
                <div v-if="premium">
                    {{premium}}元
                </div>
                <span v-if="this.info.productCode=='QYTTGZZRXPCNEW'" class="errorMsg">最低收费：50万3000元；80万4000元；100万的
                    5000元</span>
            </FormItem>
        </Form>

    </div>
</template>
<script>
    import UploadFile from '../common/UploadFile'
    import SelectJob from '@/components/common/SelectJob'
    export default {
        components: { UploadFile, SelectJob },
        props: {
            info: Object,
            formInfo: Object
        },
        data () {
            return {
                sceneList: [],//保额
                currentType: {},
                premium: '',//预估保费
                // 加费
                addPreForm: {
                    show: false,
                    form: {}
                },
                id: this.$route.params.id,
                isRenew: this.$route.query.renew || '',

                list: [],
                form: {
                    subjoinAllDay: false,
                    subjoinOwnMedicine: false,
                    subjoinProportionAdj: false
                },
                dateOptions: {},
                caseList: [],
                canDownload: false,
                errorMsg: '',
                personList: [],
                personListShow: false,
                uuid: '',
                isRefuse: '-1', //是否符合投保
                isReset: this.$route.query.reset || '', // 是否重新投保
                orderNo: this.$route.query.orderNo || '',
                checkOnce: true,
                formRules: {
                    projectDateStarts: [{
                        required: true, message: '请选择保险起期', type: 'date', validator: (rule, value, callback) => {
                            if (value) {
                                callback()
                            } else {
                                callback(new Error())
                            }
                        }
                    }],
                    productCode: [{ required: true, message: '请选择类型', trigger: 'change' }],
                    scheme: [{ required: true, message: '请选择保额', trigger: 'change' }],
                    contractType: [{ required: true, message: '请选择合同类型', trigger: 'change' }],
                }
            }
        },
        computed: {
            /*校验人员明细*/
            personListValidate () {
                let flag = true;
                this.personList.map(item => {
                    if (!item.success) {
                        flag = false;
                    }
                })
                return this.personList.length > 0 && flag;
            },
            fiveRisk () {
                let fiveRisk = false
                this.list.forEach(item => {
                    if (item.fiveRisk) fiveRisk = true
                })
                return fiveRisk
            }
        },
        watch: {
            info: {
                deep: true,
                handler (v) {
                    console.log('this.info', this.info)
                    if (v.productCode) {
                        // this.setStartTimeOption();
                    }
                    if (v.projectCost) {
                        if (this.form.scheme) {
                            let arr = this.sceneList.filter(i => i.key == this.form.scheme)
                        }
                    }
                    if (v.projectDateEnd) {
                        this.form.projectDateEnds = v.projectDateEnd.slice(0, 10)
                        this.$set(this.form, 'effectiveDateEnd', v.projectDateEnd.slice(0, 10))
                        console.log('recognize监听', this.form.effectiveDateEnd)
                    }
                }

            },
            'info.productCode'(){
                this.setStartTimeOption();
            },
            formInfo (val) {
                this.setInfo(val)
            }
        },
        created () {
            if (!this.isRenew) {
                this.setStartTimeOption();
            }

        },
        methods: {
            setInfo (obj) {
                this.$set(this.form, 'projectDateStarts', obj.effectiveDateStart)
                this.form.effectiveDateStart = obj.effectiveDateStart
                this.$set(this.form, 'projectDateEnds', obj.effectiveDateEnd)
                this.form.effectiveDateEnd = obj.effectiveDateEnd
                this.$set(this.form, 'productCode', obj.productCode)
                this.$set(this.form, 'contractType', obj.extraInfo.contractType)
                this.$set(this.form, 'premium', obj.premium)
                this.$axios.post('/broker/dict/items/plain.json', { bizId: "JIANGONG_EMPLOYER_LIABILITY", dictCode: "product_plan", productCode: obj.productCode }).then(res => {
                    this.sceneList = res
                    this.$set(this.form, 'scheme', obj.extraInfo.scheme)

                })
                this.form.schemeName = obj.extraInfo.schemeName
                this.premium = obj.premium
                this.$emit('set-amount', obj.premium)
            },
            async setStartTimeOption (limit) {
                if (!this.isRenew) {
                    let startDate = await this.getEffectiveDateEnd(this.formatDate(new Date()), 2, 'start');
                    console.log('startDate', startDate)
                    this.dateOptions = {
                        disabledDate (date) {
                            return date && (date.valueOf() < Date.parse(startDate + ' 00:00:00'))
                        }
                    }
                } else {
                    this.dateOptions = {
                        disabledDate (date) {
                            return date && (date.valueOf() < Date.parse(limit + ' 00:00:00'))
                        }
                    }
                }
            },
            // 计算保费
            getPremium () {
                if(this.info.projectCost&&this.form.scheme&&this.form.contractType&&this.currentType.minPremium&&this.form.productCode){
                    let obj = {
                        extraInfo: {
                            scheme: this.form.scheme,
                            projectCost: this.info.projectCost,
                            contractType: this.form.contractType
                        },
                        premium: this.currentType.minPremium,
                        productCode: this.form.productCode,
                    }
                    this.$axios.post('/broker/quote.json', obj).then(res => {
                        // console.log('保费计算', res)
                        this.premium = res.premium
                        this.$emit('set-amount', res.premium)
                    })
                }
                
            },
            getSceme (val) {
                this.$axios.post('/broker/dict/items/plain.json', { bizId: "JIANGONG_EMPLOYER_LIABILITY", dictCode: "product_plan", productCode: val }).then(res => {
                    this.sceneList = res
                    this.form.scheme = ''
                })
            },
            // 计算保费
            setSceme () {
                let arr = this.sceneList.filter(i => i.key == this.form.scheme)
                this.currentType = arr[0]
                this.form.schemeName = this.currentType.value
                this.form.insuranceAmount = this.currentType.amount
                if (this.info.projectCost && this.form.contractType && this.form.productCode) {
                    this.getPremium()
                }
            },
            setPreminum () {
                if (this.info.projectCost && this.form.scheme && this.form.productCode) {
                    this.form.extendField2 = this.form.contractType
                    this.getPremium()
                }
            },
            // 校验
            async val () {
                console.log('recose', this.form)

                return new Promise((resolve, rejct) => {
                    console.log('recose2222', this.$refs.form.validate())

                    this.$refs.form.validate(valid => {
                        console.log(11111111)
                        resolve(valid ? this.form : false)
                    })
                })
                // let flag = await this.$refs.form.validate();
                // return new Promise((resolve, reject) => {
                // let hasHeighType = false
                // this.list.forEach(item => {
                //     if (item.jobCategory && !isNaN(item.jobCategory) && item.jobCategory > 3) {
                //         hasHeighType = true
                //     }
                // })
                // if (this.info.productCode == 'QYTTGZZRXPCNEW' && hasHeighType && this.form.insuredPeriod < 6) { //对外新产品校验不同
                //     this.toast('包含4类或5类人员时保障期限必须为6~12个月', 'error');
                //     resolve(false)
                // } else if (this.info.productCode == 'QYTTGZZRX' && hasHeighType && this.form.insuredPeriod != 12) {
                //     this.toast('包含4类或5类人员时保障期限必须为1年', 'error');
                //     resolve(false)
                // } else if (flag && this.personListValidate) {
                //     resolve({
                //         employerTotalAmountVO: {
                //             count: this.totalData[0].count,
                //             effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
                //             effectiveDateEnd: this.form.effectiveDateEnd,
                //             insuredPeriod: this.form.insuredPeriod,
                //             totalAmount: this.totalData[0].totalAmount,
                //             uuid: this.uuid
                //         },
                //         importEmployeeVOS: this.personList,
                //         list: this.list
                //     })
                // } else {
                //     this.toast('保障计划及人员校验失败', 'error');
                //     resolve(false)
                // }
                // })
            },
            /*日期变化后获取起保终保日期*/
            dateChange (val) {
                this.form.effectiveDateStart = val
            },
            dateChanges (val) {
                this.form.effectiveDateEnd = val
            },
            // 获取保障止期，父页面fillin也会用到
            getEffectiveDateEnd (effectiveDateStart, insuredPeriod, type = 'end') {
                console.log(' this.formInfo.productCode', this.formInfo.productCode)
                return this.$axios.post('/broker/insurance/application/getEffectiveDateStartRange.json', {
                    effectiveDateStart: effectiveDateStart,
                    insuredPeriod: insuredPeriod,
                    productCode: 'TUJIAN_LUZHENG'
                }).then(res => {
                    if (type == 'end') {
                        // return res.effectiveDateEnd
                    } else {
                        return res.effectiveStartDateStart
                    }
                })
            }

        }
    }
</script>
<style scoped lang="less">
    .download-info {
        font-size: 14px;

        span {
            color: #FF9900;
            margin-left: 20px;
        }
    }

    .priceStyle {
        height: 20px;
    }

    .recognize {
        &-title {
            font-weight: bold;
        }

        &-total {
            font-size: 14px;
        }
    }

    .caseContainer {
        padding: 10px 0;
    }

    .subtitle {
        color: #FF9900;
        font-size: 14px;
        margin-left: 20px;
    }

    .downloadFile {
        font-size: 14px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .errorMsg {
        font-size: 14px;
        color: red;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/Recognize.vue